"use strict";

var _classCallCheck = require("/app/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.popoverStore = exports.PopoverStore = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var PopoverStore = /*#__PURE__*/function () {
  function PopoverStore() {
    _classCallCheck(this, PopoverStore);

    (0, _defineProperty2.default)(this, "callback", null);
  }

  _createClass(PopoverStore, [{
    key: "hide",
    value: function hide() {
      this.register(null);
    }
  }, {
    key: "register",
    value: function register(cb) {
      if (this.callback) {
        this.callback();
      }

      this.callback = cb;
    }
  }, {
    key: "unregister",
    value: function unregister(cb) {
      if (this.callback === cb) {
        this.callback = null;
      }
    }
  }]);

  return PopoverStore;
}();

exports.PopoverStore = PopoverStore;
var popoverStore = new PopoverStore();
exports.popoverStore = popoverStore;